module.exports = __webpack_public_path__ + "img/jjh1.a6982ed7.jpg";